import { render, staticRenderFns } from "./NewContentMessage.vue?vue&type=template&id=427c4cae"
import script from "./NewContentMessage.vue?vue&type=script&lang=js"
export * from "./NewContentMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports